export default "__VITE_ASSET__c5be65f0__"